import { useAuth } from '@clerk/nextjs';
import { ProfileManagement } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';
export interface ApiResponse {
  success: true;
  url: string;
  returnUrl: string;
}

export interface Params {
  return_section: ProfileManagement.AvailableOptions;
}

/**
 * React Query hook to fetch all the available useCustomerPortal for the user from stripe
 * @returns ApiResponse | undefined
 */
const useCustomerPortal = ({ return_section }: Params) => {
  const { orgId } = useAuth();
  return useQuery({
    queryKey: [Query.StripeKeys.customerPortal],
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
    enabled: false,
    queryFn: async () => {
      const response = await axios.post<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer-portal`, {
        orgId,
        return_section,
      });
      return response.data;
    },
  });
};

export { useCustomerPortal };
